module.exports = __webpack_public_path__ + "fonts/GoblinOne.a95d0a3a.eot";